import Vue from 'vue'
import VueRouter from 'vue-router'
import TabletList from '../views/TabletList'
import Dashboard from '../views/Dashboard'
import SignIn from '../views/SignIn'

Vue.use(VueRouter)
  const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/TabletList',
    name: 'TabletList',
    component: TabletList
  },
  {
    path: '/TabletDetail',
    name: 'TabletDetail',
    component: () => import(/* webpackChunkName: "tabletDetail" */ '../views/TabletDetail.vue')
  },
  {
    path: '/TabletConflict',
    name: 'TabletConflict',
    component: () => import(/* webpackChunkName: "tabletDetail" */ '../views/TabletConflict.vue')
  },
  {
    path: '/SyncSchedule',
    name: 'SyncSchedule',
    component: () => import(/* webpackChunkName: "syncSchedule" */ '../views/SyncSchedule.vue')
  },
  {
    path: '/SyncTablet',
    name: 'SyncTablet',
    component: () => import(/* webpackChunkName: "syncTablet" */ '../views/SyncTablet.vue')
  },
  {
    path: '/SyncManual',
    name: 'SyncManual',
    component: () => import(/* webpackChunkName: "syncManual" */ '../views/SyncManual.vue')
  },
  {
    path: '/admin',
    name: 'Administration',
    component: () => import(/* webpackChunkName: "settings" */ '../views/Admin.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    // route level code-splitting
    // this generates a separate chunk (settings.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue')
  },
  {
    path: '/charts',
    name: 'Charts',
    // route level code-splitting
    // this generates a separate chunk (settings.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "charts" */ '../views/Charts.vue')
  },
  {
    path: '/signin',
    name: 'signin',
    component: SignIn
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router